import type { ListBuilderList } from '../../../types';
import { createDefaultCompetitorColumns } from '../columns';
import { ACTIVE_COMPETITORS_RULE } from '../shared';

/** Every active competitor. */
export const allCompetitorsList: ListBuilderList = {
	id: 'default-competitors-all',
	cacheTTL: 600000,
	name: 'All',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createDefaultCompetitorColumns(),
	description: 'Every active competitor',
	defaultSortId: 'column-competitor-name-asc',
	filterRules: {
		competitorStatus: ACTIVE_COMPETITORS_RULE,
	},
};
